exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nbutton[data-v-20a22ddf]{\r\n    display:block;\n}\r\n", ""]);

